<div class="container m-24" fxLayout="column" fxLayoutGap="20px">
  <div fxLayout="column" fxLayoutAlign="center center" class="icon-container">
    <mat-icon>info</mat-icon>
  </div>
  <h2 class="fs-18px mb-10">{{ 'keywords.by_clicking_the_pay_now' | translate }}</h2>
  <br/>
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
    <button class="medium-button-white" fxFlex="50" mat-button (click)="closePopup()">
      {{ 'keywords.cancel' | translate }}
    </button>
    <button class="medium-button-blue" fxFlex="50" mat-button (click)="redirect()">
      {{ 'keywords.pay_now'  | translate }}
    </button>
  </div>
</div>